import * as React from 'react';

function EgdsStylesPlugin() {
    return {
        name: 'egds-styles',
        onBrowserWrapRootElement: function (context, next) {
            var setRootElement = context.setRootElement;
            setRootElement(function (RootElement) { return function (props) { return (React.createElement(React.Fragment, null,
                React.createElement(RootElement, null, props.children))); }; });
            return next(context);
        },
    };
}

export { EgdsStylesPlugin as default };
//# sourceMappingURL=browser.js.map
